import { useState } from "react";
import { Menu, X } from "lucide-react";
import { cta } from "@/lib/analytics";
import logoAsset from "@/assets/logo-sylwia-sitkowska.webp";

const nav = [
  { label: "Mastermind", href: "/mastermind" },
  { label: "Konsultacje", href: "/konsultacje" },
  { label: "Psychologia biznesu", href: "/psychologia-biznesu" },
  { label: "Wystąpienia", href: "/wystapienia" },
  { label: "Podcast", href: "/podcast" },
  { label: "O mnie", href: "/o-mnie" },
  { label: "Kontakt", href: "/kontakt" },
];

const mobileNav = [
  { label: "Start", href: "/" },
  ...nav,
  { label: "Media i publikacje", href: "/media-i-publikacje" },
];



export function SiteHeader() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-steel bg-background/92 backdrop-blur">
      <a
        href="#tresc-glowna"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:z-50 focus:bg-ink focus:px-4 focus:py-2 focus:text-sm focus:text-mist"
      >
        Przejdź do treści
      </a>
      <div className="container-page flex items-center justify-between gap-6 py-4 xl:gap-10">

        <a href="/" className="shrink-0" aria-label="Sylwia Sitkowska, strona główna">
          <img
            src={logoAsset}
            alt="Sylwia Sitkowska, psycholog"
            width={300}
            height={159}
            className="h-9 w-auto sm:h-10"
          />
        </a>

        <nav aria-label="Nawigacja główna" className="hidden items-center gap-3 xl:flex 2xl:gap-6">

          {nav.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="inline-flex min-h-11 items-center whitespace-nowrap text-[0.7rem] uppercase tracking-[0.08em] 2xl:text-xs 2xl:tracking-[0.14em] text-ink-soft transition-colors hover:text-coral-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral"
            >
              {item.label}
            </a>
          ))}
          <a href="/kontakt" {...cta("szukasz-prelegentki", "header", "prelekcja")} className="btn-base btn-primary whitespace-nowrap px-4 py-2.5 text-[0.7rem] 2xl:px-6 2xl:text-xs focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral">
            Szukasz prelegentki?
          </a>
        </nav>


        <div className="flex items-center gap-3 xl:hidden">
          <a href="/kontakt" {...cta("szukasz-prelegentki", "header", "prelekcja")} className="btn-base btn-primary hidden min-h-11 whitespace-nowrap px-4 py-2 text-sm sm:inline-flex">
            Szukasz prelegentki?
          </a>
          <button
            type="button"
            aria-label={open ? "Zamknij menu" : "Otwórz menu"}
            aria-expanded={open}
            aria-controls="menu-mobilne"
            className="inline-flex min-h-11 min-w-11 items-center justify-center rounded-sm p-2 text-ink"
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X className="size-5" /> : <Menu className="size-5" />}
          </button>
        </div>
      </div>

      {open && (
        <nav
          id="menu-mobilne"
          aria-label="Nawigacja mobilna"
          className="border-t border-border bg-background xl:hidden"
        >
          <ul className="container-page space-y-1 py-4">
            {mobileNav.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="flex min-h-11 items-center rounded-sm py-3 text-sm text-ink-soft transition-colors hover:text-coral-text focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-3">
              <a
                href="/kontakt"
                onClick={() => setOpen(false)}
                {...cta("szukasz-prelegentki", "header", "prelekcja")}
                className="btn-base btn-primary inline-flex min-h-11 px-4 py-2 text-sm"
              >
                Szukasz prelegentki?
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
  );
}
